import { render } from "./Licenses.vue?vue&type=template&id=7144305e&scoped=true"
import script from "./Licenses.vue?vue&type=script&lang=js"
export * from "./Licenses.vue?vue&type=script&lang=js"

import "./Licenses.vue?vue&type=style&index=0&id=7144305e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7144305e"]])

export default __exports__